
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: "alliance_inquire",
data() {
return {
title: "查询真伪",
security_code: "", //防伪码
record_type:"",//查询结果类型
url: window.location.href, //当前地址

};
},
components: { XInput, Group },
computed: {
securityCode: {
get: function() {
return this.security_code;
},
set: function(val) {
this.security_code = val.toUpperCase();
}
}
},
created() {
if (sessionStorage.getItem("token") == null) {
this.get_token(this.url);
} else {
this.get_conf();
this.go_result();
}
},
methods: {

change(val) {
this.security_code = val.toUpperCase();
},

get_token(url) {
var self = this;
this.$EpetJs.Common.approve(url,function() {
self.get_conf();
self.go_result();
}); //生成token
},
get_conf() {

var self = this;
this.$EpetJs.Common.get_conf(this.url, function(res) {
res.openTagList = res.openTagList || []
res.openTagList.push('wx-open-launch-weapp')
self.$wx.config(res);

});
},

go_result() {
var self = this;
var security = self.$EpetJs.Helper.getUrlParam("security");
var s = self.$EpetJs.Helper.getUrlParam("s");

if (security && security != null) {
this.inquire(security);
return;
}

if(s && s!=null) {
this.inquire(s);
return;
}
},
sleep(sleepTime){
var start = new Date().getTime();
while(true){
if(new Date().getTime()-start>sleepTime){
break;
}
}
},

go_scan() {
var self = this;
this.$wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {

var result = res.resultStr; 

var security_code = self.$EpetJs.Helper.getUrlParam("security",result);
if(!security_code){
security_code = self.$EpetJs.Helper.getUrlParam("s",result);
}

self.inquire(security_code);
},
error:function(res){
self.$vux.toast.text('扫描出错了');
}
});
},


get_user() {
var self = this;
this.$EpetJs.Common.get("public/user/detail", {}).then(({ data }) => {
if (data.status_code == "200") {
if (data.data.status == 1) {
self.inquire(this.security_code);
} else if (data.data.status == 2) {
self.$vux.toast.text("您的账号已被禁用");
}
} else {
self.$vux.toast.text(data.message);
}
});
},

inquire(codeValue) {
var self = this;
var changeCode = codeValue.replace(/\s/g, ""); 
this.$EpetJs.Common.get("/v2/public/security_codes/" + changeCode,{}).then(({ data }) => {
if (data.status_code == "200") {
let resData = data.data || {}
let business_type = resData.business_type
let business_data = resData.business_data || {}
switch(business_type) {

case 0:
sessionStorage.setItem('inquireResult',JSON.stringify(data));
this.$router.push({name: "alliance_result",query: {security_code:changeCode}});
break

case 1:
this.$router.replace(`/invite?brand_id=${business_data.brand_id}&brand_name=${business_data.brand_name}&store_id=${business_data.store_id}&store_name=${business_data.store_name}&used_status=${business_data.used_status}`)
break

case 2:
this.$router.replace(`/coin?used_status=${business_data.used_status}&coin_num=${business_data.coin_num}&coin_num_new=${business_data.coin_num_new}`)
break
}
} else {
self.$vux.toast.text(data.message);
}
});
},
}
};
